export default {
    namespaced: true,

    state: {
        activeCell: null,
        position: { x: 0, y: 0 },
    },

    getters: {

    },

    mutations: {
        setActiveCell(state, activeCell) {
            state.activeCell = activeCell;
        },

        setPosition(state, position) {
            state.position = position;
        },

    },

    actions: {
        setActiveCell({rootGetters, commit}, {type, item, position}) {

            const trimEditDisabled = rootGetters['editor/trimEditDisabled'];

            // set active cell only if the user can edit the trim
            if (trimEditDisabled) return;

            commit('setPosition', position);
            commit('setActiveCell', {type, item});
        },

        clearActiveCell({commit}) {
            commit('setActiveCell', null);
        },

    },
}